module.exports = __webpack_public_path__ + "static/img/lc.1c3a5554.svg";